import { Box, Typography } from '@mui/material';

interface Props {
  title: React.ReactNode;
  children: React.ReactNode;
}

export function AdminSection(p: Props) {
  const { title, children } = p;

  return (
    <Box sx={{ mt: 4, '&:first-of-type': { mt: 0 } }}>
      <Typography
        variant="overline"
        sx={{
          display: 'block',
          color: 'text.secondary',
          letterSpacing: 1,
          mb: 1.5,
        }}
      >
        {title}
      </Typography>

      {children}
    </Box>
  );
}
